import React from 'react';

class BaseIcon extends React.Component {
    render() {
        return null;
    }
}

BaseIcon.defaultProps = {
    primary: '#000000',
    secondary: '#FFFFFF',
};

export default BaseIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/BaseIcon.js